import React from "react"
import Heading from "../../common/Heading"
import "./Featured.css"
import FeaturedCard from "./FeaturedCard"
import { useLanguage } from "../../../context/LanguageContext"

const Featured = () => {
  const { content } = useLanguage()
  const { featured } = content.home

  return (
    <>
      <section className='featured background'>
        <div className='container'>
          <Heading title={featured.title} subtitle={featured.subtitle} />
          <FeaturedCard />
        </div>
      </section>
    </>
  )
}

export default Featured
